import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import * as serviceWorker from "@_core/serviceWorker";
import Routes from "@_core/Routes";
import { Store } from "@_core/Store";
import "./index.css";
import SingleSignOnPage from "@_pages/SingleSignOn/SingleSignOn";



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    {window.location.pathname === "/sso" ? (
      <SingleSignOnPage />
    ) : (
      <Provider store={Store}>
        <Routes />
      </Provider>
    )}
    ,
  </>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
